import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import './style.css'
import Account from './views/account'
import Home from './views/home'
import Support from './views/support'
import Login from './views/login'
import Signup from './views/signup'
import Subscription from './views/subscription'
import Docs from './views/docs'
import Accounts from './views/accounts'
import Verifyemail from './views/verifyemail'
import { useEffect } from 'react'
import {check_if_is_authenticated} from "./utils/helper"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
   useEffect(() => {
    check_if_is_authenticated();
  }, []);
  
  return (
    <Router>
      <div>
        <Route component={Account} exact path="/account" />
        <Route component={Home} exact path="/" />
        <Route component={Support} exact path="/support" />
        <Route component={Login} exact path="/login" />
        <Route component={Signup} exact path="/signup" />
        <Route component={Subscription} exact path="/subscription" />
        <Route component={Accounts} exact path="/accounts" />
        <Route component={Docs} exact path="/docs" />
        <Route component={Verifyemail} exact path="/verifyemail" />
      </div>
      <ToastContainer autoClose={1000} />
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
